export const loginStyles = {
  submit: {
    marginTop: '1em',
    background: '#efa817',
    color: '#fff',
    justifyContent: 'center'
  }
}
